export type CreditCardBrand =
  | "mastercard"
  | "amex"
  | "visa"
  | "discover"
  | "diners"
  | "jcb"
  | "unionpay"
  | "elo";
export interface CreditCardData {
  name: string;
  logo: JSX.Element;
}
interface PaymentMethodDetails {
  bankName?: string;
  brand?: CreditCardBrand;
  lastFour: string;
  expirationDate?: string;
  billingName?: string;
}

export interface PaymentMethod {
  isDefault: boolean;
  paymentMethodId: string;
  paymentMethodInfo: PaymentMethodDetails;
}

export const AddNewPaymentMethod = "add-new" as const;
